import {
  t as JsonReference,
  r as JsonObject,
  l as JsonArray,
  m as JsonBoolean,
  q as JsonNumber,
  u as JsonString,
  p as JsonNull,
  h as Companion_getInstance,
  n as valueOf,
  v as JsonUnreferencableObject,
  f as ComplexObjectKind_PRIMITIVE_getInstance,
  i as JsonNull_getInstance,
  b as ComplexObjectKind_ENUM_getInstance,
  g as ComplexObjectKind_SET_getInstance,
  c as ComplexObjectKind_LIST_getInstance,
  a as ComplexObjectKind_ARRAY_getInstance,
  d as ComplexObjectKind_MAP_getInstance,
  s as JsonReferencableObject,
  e as ComplexObjectKind_OBJECT_getInstance,
  w as JsonValue,
  o as JsonDocument,
  k as Json_getInstance,
} from './net.akehurst.kotlin.json-json.mjs';
import {
  f2 as copyToArray,
  e6 as isInterface,
  k9 as IllegalStateException,
  s9 as THROW_CCE,
  r6 as toString,
  g8 as substringAfter,
  j4 as toSet,
  y9 as ensureNotNull,
  h8 as substringBeforeLast,
  e8 as substringAfterLast,
  e1 as ArrayList,
  f1 as Collection,
  a4 as sortedWith,
  a2 as collectionSizeOrDefault,
  t3 as plus,
  l2 as firstOrNull,
  z1 as checkIndexOverflow,
  q9 as Pair,
  d3 as mapCapacity,
  u6 as coerceAtLeast,
  j1 as LinkedHashMap,
  p5 as classMeta,
  ga as VOID,
  o6 as setMetadataFor,
  n4 as compareValues,
  g6 as isObject,
  j5 as captureStack,
  r9 as RuntimeException,
  s5 as equals,
  a1 as Unit_getInstance,
  a as getKClassFromExpression,
  y2 as last,
  h2 as emptyList,
  b3 as listOf,
  i2 as emptyMap,
  v as PrimitiveClasses_getInstance,
  m9 as Long,
  b as getKClass,
  t9 as THROW_ISE,
  g9 as Enum,
  x5 as getStringHashCode,
} from './kotlin-kotlin-stdlib.mjs';
import {
  k as PrimitiveType,
  j as EnumType,
  i as DataType,
  b as PropertyCharacteristic_CONSTRUCTOR_getInstance,
  c as PropertyCharacteristic_IDENTITY_getInstance,
  d as PropertyCharacteristic_MEMBER_getInstance,
} from './net.akehurst.language-type-model.mjs';
import {
  c as PrimitiveMapper,
  a as Companion_getInstance_0,
} from './net.akehurst.kotlin.komposite-komposite-api.mjs';
import {
  g as valueOf_0,
  e as construct,
  f as set,
  d as WalkInfo,
  b as DatatypeRegistry2,
  c as Builder,
  a as Companion_getInstance_1,
} from './net.akehurst.kotlin.komposite-komposite-common.mjs';
import { a as Stack } from './net.akehurst.kotlinx-kotlinx-collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.d4m_1 = function_0;
  }
  rc(a, b) {
    return this.d4m_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class FromJsonConverter {
  constructor(registry) {
    this.registry = registry;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.c4m_1 = tmp$ret$0;
  }
  l1v() {
    return this.registry;
  }
  e4m(path, json, targetKlass) {
    var tmp0_safe_receiver = targetKlass;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertTo.<anonymous>' call
      tmp$ret$0 = this.registry.s4i(tmp0_safe_receiver);
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    var targetType = tmp;
    var tmp1_safe_receiver = targetType;
    var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.instance();
    var tmp_0 = convertValue(this, path, json, type);
    return (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
  }
  convertTo(path, json, targetKlass, $super) {
    targetKlass = targetKlass === VOID ? null : targetKlass;
    return this.e4m(path, json, targetKlass);
  }
}
class KSerialiserJsonException extends RuntimeException {
  static new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException(message) {
    var $this = super.u6(message);
    init_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException($this);
    return $this;
  }
}
class FoundReferenceException extends RuntimeException {
  static new_net_akehurst_kotlin_kserialisation_json_KSerialiserJson_FoundReferenceException() {
    var $this = super.tg();
    init_net_akehurst_kotlin_kserialisation_json_KSerialiserJson_FoundReferenceException($this);
    return $this;
  }
}
class KSerialiserJson {
  constructor() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.l4m_1 = tmp$ret$0;
    this.registry = new DatatypeRegistry2();
  }
  m4m() {
    return this.l4m_1;
  }
  l1v() {
    return this.registry;
  }
  calcReferencePath(root, targetValue) {
    var tmp;
    if (this.l4m_1.r3(targetValue)) {
      tmp = ensureNotNull(this.l4m_1.u3(targetValue));
    } else {
      var resultPath = {_v: null};
      var tmp$ret$0;
      // Inline function 'net.akehurst.kotlin.komposite.common.kompositeWalker' call
      var tmp0_kompositeWalker = this.registry;
      var builder = new Builder();
      // Inline function 'net.akehurst.kotlin.kserialisation.json.KSerialiserJson.calcReferencePath.<anonymous>' call
      builder.i4k(KSerialiserJson$calcReferencePath$lambda);
      builder.e4k(KSerialiserJson$calcReferencePath$lambda_0);
      builder.a4k(KSerialiserJson$calcReferencePath$lambda_1(this, targetValue, resultPath));
      builder.c4k(KSerialiserJson$calcReferencePath$lambda_2);
      tmp$ret$0 = builder.p4k(tmp0_kompositeWalker);
      var walker = tmp$ret$0;
      try {
        var result = walker.m4l(new WalkInfo(emptyList(), false), root);
      } catch ($p) {
        if ($p instanceof FoundReferenceException) {
          var e = $p;
        } else {
          throw $p;
        }
      }
      var tmp0_elvis_lhs = resultPath._v;
      tmp = tmp0_elvis_lhs == null ? listOf('$unknown ' + getKClassFromExpression(targetValue).n9()) : tmp0_elvis_lhs;
    }
    return tmp;
  }
  confgureFromKompositeString(kompositeModel) {
    this.registry.q4i(kompositeModel, emptyMap());
  }
  confgureFromKompositeModel(kompositeModel) {
    this.registry.r4i(kompositeModel, emptyMap());
  }
  registerKotlinStdPrimitives() {
    this.registry.r4i(Companion_getInstance_1().j4i_1, emptyMap());
    var tmp = PrimitiveClasses_getInstance().z9();
    var tmp_0 = KSerialiserJson$registerKotlinStdPrimitives$lambda;
    this.registerPrimitive(tmp, tmp_0, KSerialiserJson$registerKotlinStdPrimitives$lambda_0);
    var tmp_1 = PrimitiveClasses_getInstance().aa();
    var tmp_2 = KSerialiserJson$registerKotlinStdPrimitives$lambda_1;
    this.registerPrimitiveAsObject(tmp_1, tmp_2, KSerialiserJson$registerKotlinStdPrimitives$lambda_2);
    var tmp_3 = PrimitiveClasses_getInstance().ba();
    var tmp_4 = KSerialiserJson$registerKotlinStdPrimitives$lambda_3;
    this.registerPrimitiveAsObject(tmp_3, tmp_4, KSerialiserJson$registerKotlinStdPrimitives$lambda_4);
    var tmp_5 = PrimitiveClasses_getInstance().ca();
    var tmp_6 = KSerialiserJson$registerKotlinStdPrimitives$lambda_5;
    this.registerPrimitiveAsObject(tmp_5, tmp_6, KSerialiserJson$registerKotlinStdPrimitives$lambda_6);
    var tmp_7 = getKClass(Long);
    var tmp_8 = KSerialiserJson$registerKotlinStdPrimitives$lambda_7;
    this.registerPrimitiveAsObject(tmp_7, tmp_8, KSerialiserJson$registerKotlinStdPrimitives$lambda_8);
    var tmp_9 = PrimitiveClasses_getInstance().da();
    var tmp_10 = KSerialiserJson$registerKotlinStdPrimitives$lambda_9;
    this.registerPrimitiveAsObject(tmp_9, tmp_10, KSerialiserJson$registerKotlinStdPrimitives$lambda_10);
    var tmp_11 = PrimitiveClasses_getInstance().ea();
    var tmp_12 = KSerialiserJson$registerKotlinStdPrimitives$lambda_11;
    this.registerPrimitiveAsObject(tmp_11, tmp_12, KSerialiserJson$registerKotlinStdPrimitives$lambda_12);
    var tmp_13 = PrimitiveClasses_getInstance().ga();
    var tmp_14 = KSerialiserJson$registerKotlinStdPrimitives$lambda_13;
    this.registerPrimitive(tmp_13, tmp_14, KSerialiserJson$registerKotlinStdPrimitives$lambda_14);
  }
  registerPrimitive(cls, toJson, toPrimitive) {
    var tmp0_elvis_lhs = this.registry.s4i(cls);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('The primitive is not defined in the Komposite configuration');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var dt = tmp;
    this.registry.p4i(Companion_getInstance_0().j4h(cls, getKClass(JsonValue), toJson, toPrimitive));
  }
  registerPrimitiveAsObject(cls, toJson, fromJson) {
    var tmp0_elvis_lhs = this.registry.s4i(cls);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('The primitive is not defined in the Komposite configuration');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var dt = tmp;
    var toJsonMpr = KSerialiserJson$registerPrimitiveAsObject$lambda(dt, toJson);
    var toPrimitive = KSerialiserJson$registerPrimitiveAsObject$lambda_0(fromJson);
    var mapper = Companion_getInstance_0().j4h(cls, getKClass(JsonObject), toJsonMpr, toPrimitive);
    this.registry.p4i(mapper);
  }
  toJson(root, data) {
    this.l4m_1.n1();
    var doc = new JsonDocument('json');
    var currentObjStack = {_v: new Stack()};
    var tmp$ret$0;
    // Inline function 'net.akehurst.kotlin.komposite.common.kompositeWalker' call
    var tmp0_kompositeWalker = this.registry;
    var builder = new Builder();
    // Inline function 'net.akehurst.kotlin.kserialisation.json.KSerialiserJson.toJson.<anonymous>' call
    builder.z4j(KSerialiserJson$toJson$lambda);
    builder.o4k(KSerialiserJson$toJson$lambda_0);
    builder.m4k(KSerialiserJson$toJson$lambda_1(this));
    builder.n4k(KSerialiserJson$toJson$lambda_2(this));
    builder.l4k(KSerialiserJson$toJson$lambda_3(this, root, doc));
    builder.i4k(KSerialiserJson$toJson$lambda_4(currentObjStack));
    builder.j4k(KSerialiserJson$toJson$lambda_5(currentObjStack));
    builder.k4k(KSerialiserJson$toJson$lambda_6(currentObjStack));
    builder.e4k(KSerialiserJson$toJson$lambda_7(currentObjStack));
    builder.f4k(KSerialiserJson$toJson$lambda_8(currentObjStack));
    builder.g4k(KSerialiserJson$toJson$lambda_9(currentObjStack));
    builder.h4k(KSerialiserJson$toJson$lambda_10(currentObjStack));
    builder.a4k(KSerialiserJson$toJson$lambda_11(doc, this, currentObjStack));
    builder.b4k(KSerialiserJson$toJson$lambda_12(currentObjStack));
    builder.c4k(KSerialiserJson$toJson$lambda_13);
    builder.d4k(KSerialiserJson$toJson$lambda_14(currentObjStack));
    tmp$ret$0 = builder.p4k(tmp0_kompositeWalker);
    var walker = tmp$ret$0;
    var result = walker.m4l(new WalkInfo(emptyList(), JsonNull_getInstance()), data);
    doc.x4f_1 = result.w4l_1;
    return doc;
  }
  n4m(jsonString, targetKlass) {
    var json = Json_getInstance().process(jsonString);
    var conv = new FromJsonConverter(this.registry);
    var tmp = conv.convertTo(emptyList(), json.x4f_1, targetKlass);
    return isObject(tmp) ? tmp : THROW_CCE();
  }
  toData(jsonString, targetKlass, $super) {
    targetKlass = targetKlass === VOID ? null : targetKlass;
    return this.n4m(jsonString, targetKlass);
  }
}
class TestEnumEEE extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get RED() {
    return TestEnumEEE_RED_getInstance();
  }
  static get GREEN() {
    return TestEnumEEE_GREEN_getInstance();
  }
  static get BLUE() {
    return TestEnumEEE_BLUE_getInstance();
  }
}
class TestClassAAA {
  constructor(prop1, comp) {
    this.prop1 = prop1;
    this.comp = comp;
    this.q4m_1 = -1;
    this.refr = null;
  }
  r4m() {
    return this.prop1;
  }
  s4m(_set____db54di) {
    this.comp = _set____db54di;
  }
  t4m() {
    return this.comp;
  }
  u4m(_set____db54di) {
    this.refr = _set____db54di;
  }
  v4m() {
    return this.refr;
  }
  w4m(value) {
    this.q4m_1 = value;
  }
  x4m() {
    return this.q4m_1;
  }
  hashCode() {
    return getStringHashCode(this.prop1);
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (tmp0_subject instanceof TestClassAAA) {
      tmp = this.prop1 === other.prop1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  get prop2() {
    return this.x4m();
  }
  set prop2(value) {
    this.w4m(value);
  }
}
//endregion
function convertValue($this, path, json, targetType) {
  var tmp;
  if (json instanceof JsonNull) {
    tmp = null;
  } else {
    if (json instanceof JsonString) {
      tmp = convertPrimitive($this, json, 'String');
    } else {
      if (json instanceof JsonNumber) {
        tmp = convertNumber($this, json, targetType);
      } else {
        if (json instanceof JsonBoolean) {
          tmp = convertPrimitive($this, json, 'Boolean');
        } else {
          if (json instanceof JsonArray) {
            // Inline function 'kotlin.collections.toTypedArray' call
            var tmp0_toTypedArray = convertList($this, path, json, targetType);
            tmp = copyToArray(tmp0_toTypedArray);
          } else {
            if (json instanceof JsonObject) {
              tmp = convertObject($this, path, json, targetType);
            } else {
              if (json instanceof JsonReference) {
                tmp = convertReference($this, path, json);
              } else {
                throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('Cannot convert ' + json);
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function convertNumber($this, json, targetType) {
  var tmp;
  var tmp_0;
  if (!(null == targetType)) {
    var tmp_1 = targetType.type;
    tmp_0 = isInterface(tmp_1, PrimitiveType);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp_2;
    switch (targetType.type.name) {
      case 'Int':
        tmp_2 = json.md();
        break;
      case 'Double':
        tmp_2 = json.fe();
        break;
      case 'Long':
        tmp_2 = json.id();
        break;
      case 'Float':
        tmp_2 = json.m4f();
        break;
      case 'Byte':
        tmp_2 = json.k4f();
        break;
      case 'Short':
        tmp_2 = json.l4f();
        break;
      default:
        throw IllegalStateException.y1('HJsonNumber cannot be converted, not a std type, please use a primitiveAsObject converter');
    }
    tmp = tmp_2;
  } else {
    tmp = json.fe();
  }
  return tmp;
}
function convertPrimitive($this, json, typeName) {
  var tmp0_elvis_lhs = $this.registry.u4i(typeName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('Do not know how to convert ' + typeName + ' from json, did you register its converter');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var mapper = tmp;
  return (mapper instanceof PrimitiveMapper ? mapper : THROW_CCE()).n4h_1(json);
}
function convertReference($this, path, json) {
  var tmp;
  if ($this.c4m_1.r3(json.t4f_1)) {
    tmp = $this.c4m_1.u3(json.t4f_1);
  } else {
    var resolved = json.u4f();
    tmp = convertValue($this, json.t4f_1, resolved, null);
  }
  return tmp;
}
function convertObject($this, path, json, targetType) {
  var tmp;
  if ($this.c4m_1.r3(path)) {
    tmp = ensureNotNull($this.c4m_1.u3(path));
  } else {
    var tmp0_safe_receiver = json.q4f_1.u3(Companion_getInstance().c4g_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v4e();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h4f_1;
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      var tmp0_error = "Json property '" + Companion_getInstance().c4g_1 + "'Should be a JsonString value";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var type = tmp_0;
    var kind = valueOf(substringAfter(type, '$'));
    var tmp_1;
    switch (kind.bc_1) {
      case 2:
        var tmp4_elvis_lhs = json.q4f_1.u3(Companion_getInstance().g4g_1);
        var tmp_2;
        if (tmp4_elvis_lhs == null) {
          throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('Incorrect JSON, no ' + Companion_getInstance().g4g_1 + ' property found');
        } else {
          tmp_2 = tmp4_elvis_lhs;
        }

        var elements = tmp_2;
        // Inline function 'kotlin.collections.toTypedArray' call

        var tmp1_toTypedArray = convertList($this, path, elements.x4e(), targetType);
        tmp_1 = copyToArray(tmp1_toTypedArray);
        break;
      case 4:
        var tmp5_elvis_lhs = json.q4f_1.u3(Companion_getInstance().g4g_1);
        var tmp_3;
        if (tmp5_elvis_lhs == null) {
          throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('Incorrect JSON, no ' + Companion_getInstance().g4g_1 + ' property found');
        } else {
          tmp_3 = tmp5_elvis_lhs;
        }

        var elements_0 = tmp_3;
        tmp_1 = convertList($this, path, elements_0.x4e(), targetType);
        break;
      case 5:
        var tmp6_elvis_lhs = json.q4f_1.u3(Companion_getInstance().g4g_1);
        var tmp_4;
        if (tmp6_elvis_lhs == null) {
          throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('Incorrect JSON, no ' + Companion_getInstance().g4g_1 + ' property found');
        } else {
          tmp_4 = tmp6_elvis_lhs;
        }

        var elements_1 = tmp_4;
        tmp_1 = toSet(convertList($this, path, elements_1.x4e(), targetType));
        break;
      case 6:
        var tmp7_elvis_lhs = json.q4f_1.u3(Companion_getInstance().h4g_1);
        var tmp_5;
        if (tmp7_elvis_lhs == null) {
          throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('Incorrect JSON, no ' + Companion_getInstance().h4g_1 + ' property found');
        } else {
          tmp_5 = tmp7_elvis_lhs;
        }

        var elements_2 = tmp_5;
        tmp_1 = convertMap($this, path, elements_2.x4e(), targetType);
        break;
      case 3:
        tmp_1 = convertObject2Object($this, path, json, targetType);
        break;
      case 0:
        tmp_1 = convertObject2Primitive($this, path, json, targetType);
        break;
      case 1:
        var tmp8_elvis_lhs = convertObject2Enum($this, path, json);
        var tmp_6;
        if (tmp8_elvis_lhs == null) {
          throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('Incorrect JSON, no enum value found for ' + json.z4e('', ''));
        } else {
          tmp_6 = tmp8_elvis_lhs;
        }

        tmp_1 = tmp_6;
        break;
      default:
        tmp_1 = convertObject2Object($this, path, json, targetType);
        break;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function convertObject2Primitive($this, path, json, targetType) {
  var clsName = ensureNotNull(json.q4f_1.u3(Companion_getInstance().d4g_1)).v4e().h4f_1;
  var ns = substringBeforeLast(clsName, '.');
  var sn = substringAfterLast(clsName, '.');
  var tmp0_elvis_lhs = $this.registry.u4i(sn);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('Do not know how to convert ' + sn + ' from json, did you register its converter');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var mapper = tmp;
  return (mapper instanceof PrimitiveMapper ? mapper : THROW_CCE()).n4h_1(json);
}
function convertObject2Enum($this, path, json) {
  var clsName = ensureNotNull(json.q4f_1.u3(Companion_getInstance().d4g_1)).v4e().h4f_1;
  var ns = substringBeforeLast(clsName, '.');
  var sn = substringAfterLast(clsName, '.');
  var tmp = $this.registry.findFirstByNameOrNull(sn);
  var tmp0_elvis_lhs = (tmp == null ? true : isInterface(tmp, EnumType)) ? tmp : THROW_CCE();
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var tmp0_error = 'Cannot find enum ' + clsName + ', is it in the konfiguration';
    throw IllegalStateException.y1(toString(tmp0_error));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var et = tmp_0;
  var value = ensureNotNull(json.q4f_1.u3(Companion_getInstance().f4g_1)).v4e().h4f_1;
  return valueOf_0(et, value);
}
function convertObject2Object($this, path, json, targetType) {
  var tmp0_safe_receiver = json.q4f_1.u3(Companion_getInstance().d4g_1);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v4e();
  var tmp4_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h4f_1;
  var tmp;
  if (tmp4_elvis_lhs == null) {
    var tmp3_safe_receiver = targetType == null ? null : targetType.type;
    tmp = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.qualifiedName;
  } else {
    tmp = tmp4_elvis_lhs;
  }
  var tmp5_elvis_lhs = tmp;
  var tmp_0;
  if (tmp5_elvis_lhs == null) {
    throw IllegalStateException.y1('Cannot determine target type for Json object');
  } else {
    tmp_0 = tmp5_elvis_lhs;
  }
  var clsName = tmp_0;
  var ns = substringBeforeLast(clsName, '.');
  var sn = substringAfterLast(clsName, '.');
  var tmp_1 = $this.registry.findFirstByNameOrNull(sn);
  var tmp6_elvis_lhs = (tmp_1 == null ? true : isInterface(tmp_1, DataType)) ? tmp_1 : THROW_CCE();
  var tmp_2;
  if (tmp6_elvis_lhs == null) {
    var tmp0_error = 'Cannot find datatype ' + clsName + ', is it in the registered Konfigurations';
    throw IllegalStateException.y1(toString(tmp0_error));
  } else {
    tmp_2 = tmp6_elvis_lhs;
  }
  var dt = tmp_2;
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.collections.filter' call
  var tmp1_filter = dt.property.k3();
  // Inline function 'kotlin.collections.filterTo' call
  var tmp0_filterTo = ArrayList.i4();
  var tmp0_iterator = tmp1_filter.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertObject2Object.<anonymous>' call
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp0_any = element.characteristics;
      var tmp_3;
      if (isInterface(tmp0_any, Collection)) {
        tmp_3 = tmp0_any.y();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator_0 = tmp0_any.u();
      while (tmp0_iterator_0.h1()) {
        var element_0 = tmp0_iterator_0.j1();
        // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertObject2Object.<anonymous>.<anonymous>' call
        if (element_0.equals(PropertyCharacteristic_IDENTITY_getInstance()) ? true : element_0.equals(PropertyCharacteristic_CONSTRUCTOR_getInstance())) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      tmp0_filterTo.e1(element);
    }
  }
  var tmp$ret$5;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_4 = FromJsonConverter$convertObject2Object$lambda;
  tmp$ret$5 = new sam$kotlin_Comparator$0(tmp_4);
  var constructorProps = sortedWith(tmp0_filterTo, tmp$ret$5);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(constructorProps, 10));
  var tmp0_iterator_1 = constructorProps.u();
  while (tmp0_iterator_1.h1()) {
    var item = tmp0_iterator_1.j1();
    var tmp$ret$7;
    // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertObject2Object.<anonymous>' call
    var jsonPropValue = json.q4f_1.u3(item.name);
    var tmp_5;
    if (null == jsonPropValue) {
      tmp_5 = null;
    } else {
      var propType = item.typeInstance;
      var v = convertValue($this, plus(path, item.name), jsonPropValue, propType);
      tmp_5 = v;
    }
    tmp$ret$7 = tmp_5;
    tmp0_mapTo.e1(tmp$ret$7);
  }
  var consArgs = tmp0_mapTo;
  var tmp$ret$10;
  // Inline function 'kotlin.collections.toTypedArray' call
  tmp$ret$10 = copyToArray(consArgs);
  var obj = construct(dt, tmp$ret$10.slice());
  // Inline function 'kotlin.collections.set' call
  $this.c4m_1.m3(path, obj);
  // Inline function 'kotlin.collections.filter' call
  var tmp4_filter = dt.allProperty.k3();
  // Inline function 'kotlin.collections.filterTo' call
  var tmp0_filterTo_0 = ArrayList.i4();
  var tmp0_iterator_2 = tmp4_filter.u();
  while (tmp0_iterator_2.h1()) {
    var element_1 = tmp0_iterator_2.j1();
    // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertObject2Object.<anonymous>' call
    var tmp$ret$11;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp0_any_0 = element_1.characteristics;
      var tmp_6;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp_6 = tmp0_any_0.y();
      } else {
        tmp_6 = false;
      }
      if (tmp_6) {
        tmp$ret$11 = false;
        break $l$block_2;
      }
      var tmp0_iterator_3 = tmp0_any_0.u();
      while (tmp0_iterator_3.h1()) {
        var element_2 = tmp0_iterator_3.j1();
        // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertObject2Object.<anonymous>.<anonymous>' call
        if (element_2.equals(PropertyCharacteristic_MEMBER_getInstance())) {
          tmp$ret$11 = true;
          break $l$block_2;
        }
      }
      tmp$ret$11 = false;
    }
    if (tmp$ret$11) {
      tmp0_filterTo_0.e1(element_1);
    }
  }
  var memberProps = tmp0_filterTo_0;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_4 = memberProps.u();
  while (tmp0_iterator_4.h1()) {
    var element_3 = tmp0_iterator_4.j1();
    // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertObject2Object.<anonymous>' call
    var jsonPropValue_0 = json.q4f_1.u3(element_3.name);
    if (!(null == jsonPropValue_0)) {
      var propType_0 = element_3.typeInstance;
      var value = convertValue($this, plus(path, element_3.name), jsonPropValue_0, propType_0);
      set(element_3, obj, value);
    }
  }
  return obj;
}
function convertList($this, path, json, targetType) {
  var tmp1_safe_receiver = targetType == null ? null : targetType.typeArguments;
  var elementType = tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
  var path_elements = plus(path, Companion_getInstance().g4g_1);
  // Inline function 'kotlin.collections.mapIndexed' call
  var tmp0_mapIndexed = json.o4f_1;
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var tmp0_mapIndexedTo = ArrayList.f4(collectionSizeOrDefault(tmp0_mapIndexed, 10));
  var index = 0;
  var tmp0_iterator = tmp0_mapIndexed.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertList.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var tmp1_anonymous = checkIndexOverflow(tmp1);
    tmp$ret$0 = convertValue($this, plus(path_elements, '' + tmp1_anonymous), item, elementType);
    tmp0_mapIndexedTo.e1(tmp$ret$0);
  }
  return tmp0_mapIndexedTo;
}
function convertMap($this, path, json, targetType) {
  var path_elements = plus(path, Companion_getInstance().h4g_1);
  // Inline function 'kotlin.collections.associate' call
  // Inline function 'kotlin.collections.mapIndexed' call
  var tmp0_mapIndexed = json.o4f_1;
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var tmp0_mapIndexedTo = ArrayList.f4(collectionSizeOrDefault(tmp0_mapIndexed, 10));
  var index = 0;
  var tmp0_iterator = tmp0_mapIndexed.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertMap.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var tmp1_anonymous = checkIndexOverflow(tmp1);
    var path_entry = plus(path_elements, '' + tmp1_anonymous);
    var jKey = ensureNotNull(item.w4e().q4f_1.u3(Companion_getInstance().e4g_1));
    var jValue = ensureNotNull(item.w4e().q4f_1.u3(Companion_getInstance().f4g_1));
    var pathk = plus(path_entry, Companion_getInstance().e4g_1);
    var pathv = plus(path_entry, Companion_getInstance().f4g_1);
    var key = convertValue($this, pathk, jKey, null);
    var value = convertValue($this, pathv, jValue, null);
    tmp$ret$0 = new Pair(key, value);
    tmp0_mapIndexedTo.e1(tmp$ret$0);
  }
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_mapIndexedTo, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var tmp0_associateTo = LinkedHashMap.o8(capacity);
  var tmp0_iterator_0 = tmp0_mapIndexedTo.u();
  while (tmp0_iterator_0.h1()) {
    var element = tmp0_iterator_0.j1();
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertMap.<anonymous>' call
    tmp0_associateTo.m3(element.ri_1, element.si_1);
  }
  return tmp0_associateTo;
}
function FromJsonConverter$convertObject2Object$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertObject2Object.<anonymous>' call
  var tmp = a.index;
  var tmp$ret$1;
  // Inline function 'net.akehurst.kotlin.kserialisation.json.FromJsonConverter.convertObject2Object.<anonymous>' call
  tmp$ret$1 = b.index;
  return compareValues(tmp, tmp$ret$1);
}
function init_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.h4m_1);
}
function init_net_akehurst_kotlin_kserialisation_json_KSerialiserJson_FoundReferenceException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.k4m_1);
}
function KSerialiserJson$calcReferencePath$lambda(path, info, type, coll) {
  return new WalkInfo(info.v4l_1, info.w4l_1);
}
function KSerialiserJson$calcReferencePath$lambda_0(path, info, map) {
  return new WalkInfo(info.v4l_1, info.w4l_1);
}
function KSerialiserJson$calcReferencePath$lambda_1(this$0, $targetValue, $resultPath) {
  return function (path, info, obj, datatype) {
    var tmp0_set = this$0.l4m_1;
    tmp0_set.m3(obj, path);
    var tmp;
    if (equals(obj, $targetValue)) {
      $resultPath._v = path;
      throw FoundReferenceException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJson_FoundReferenceException();
    }
    return new WalkInfo(info.v4l_1, equals(obj, $targetValue));
  };
}
function KSerialiserJson$calcReferencePath$lambda_2(path, info, property) {
  return new WalkInfo(info.v4l_1, info.w4l_1);
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda(value) {
  return new JsonBoolean(value);
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_0(json) {
  return json.p4e().n4f_1;
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_1(value) {
  return new JsonNumber(value.toString());
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_2(json) {
  return json.u4e().k4f();
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_3(value) {
  return new JsonNumber(value.toString());
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_4(json) {
  return json.u4e().l4f();
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_5(value) {
  return new JsonNumber(value.toString());
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_6(json) {
  return json.u4e().md();
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_7(value) {
  return new JsonNumber(value.toString());
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_8(json) {
  return json.u4e().id();
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_9(value) {
  return new JsonNumber(value.toString());
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_10(json) {
  return json.u4e().m4f();
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_11(value) {
  return new JsonNumber(value.toString());
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_12(json) {
  return json.u4e().fe();
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_13(value) {
  return new JsonString(value);
}
function KSerialiserJson$registerKotlinStdPrimitives$lambda_14(json) {
  return json.v4e().h4f_1;
}
function KSerialiserJson$registerPrimitiveAsObject$lambda($dt, $toJson) {
  return function (value) {
    var obj = new JsonUnreferencableObject();
    obj.r4f(Companion_getInstance().c4g_1, ComplexObjectKind_PRIMITIVE_getInstance().b4g());
    obj.r4f(Companion_getInstance().d4g_1, new JsonString($dt.qualifiedName));
    obj.r4f(Companion_getInstance().f4g_1, $toJson(value));
    return obj;
  };
}
function KSerialiserJson$registerPrimitiveAsObject$lambda_0($fromJson) {
  return function (json) {
    var jsonValue = ensureNotNull(json.q4f_1.u3(Companion_getInstance().f4g_1));
    return $fromJson(jsonValue);
  };
}
function KSerialiserJson$toJson$lambda($this$configure) {
  $this$configure.a4j_1 = Companion_getInstance().g4g_1;
  $this$configure.b4j_1 = Companion_getInstance().h4g_1;
  $this$configure.c4j_1 = Companion_getInstance().e4g_1;
  $this$configure.d4j_1 = Companion_getInstance().f4g_1;
  return Unit_getInstance();
}
function KSerialiserJson$toJson$lambda_0(path, info) {
  return new WalkInfo(info.v4l_1, JsonNull_getInstance());
}
function KSerialiserJson$toJson$lambda_1(this$0) {
  return function (path, info, primitive, mapper) {
    var clsName = ensureNotNull(getKClassFromExpression(primitive).n9());
    var tmp0_elvis_lhs = this$0.registry.findFirstByNameOrNull(clsName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException("The primitive '" + clsName + "' is not defined in the Komposite configuration");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var dt = tmp;
    var tmp1_safe_receiver = (mapper == null ? true : mapper instanceof PrimitiveMapper) ? mapper : THROW_CCE();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m4h_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver(primitive);
    var tmp_0;
    if (tmp3_elvis_lhs == null) {
      throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException("Do not know how to convert '" + clsName + "' to json, did you register its converter");
    } else {
      tmp_0 = tmp3_elvis_lhs;
    }
    var json = tmp_0;
    return new WalkInfo(info.v4l_1, json);
  };
}
function KSerialiserJson$toJson$lambda_2(this$0) {
  return function (path, info, enum_0) {
    var clsName = ensureNotNull(getKClassFromExpression(enum_0).n9());
    var tmp0_elvis_lhs = this$0.registry.findFirstByNameOrNull(clsName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException("The enum '" + clsName + "' is not defined in the Komposite configuration");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var dt = tmp;
    var value = new JsonString(enum_0.ac_1);
    var obj = new JsonUnreferencableObject();
    obj.r4f(Companion_getInstance().c4g_1, ComplexObjectKind_ENUM_getInstance().b4g());
    obj.r4f(Companion_getInstance().d4g_1, new JsonString(dt.qualifiedName));
    obj.r4f(Companion_getInstance().f4g_1, value);
    return new WalkInfo(info.v4l_1, obj);
  };
}
function KSerialiserJson$toJson$lambda_3(this$0, $root, $doc) {
  return function (path, info, value, property) {
    var refPath = this$0.calcReferencePath($root, value);
    var ref = new JsonReference($doc, refPath);
    return new WalkInfo(path, ref);
  };
}
function KSerialiserJson$toJson$lambda_4($currentObjStack) {
  return function (path, info, type, coll) {
    var elements = new JsonArray();
    $currentObjStack._v.push(elements);
    return new WalkInfo(info.v4l_1, elements);
  };
}
function KSerialiserJson$toJson$lambda_5($currentObjStack) {
  return function (path, info, element) {
    var tmp = $currentObjStack._v.peek();
    var elements = tmp instanceof JsonArray ? tmp : THROW_CCE();
    elements.p4f(info.w4l_1);
    return new WalkInfo(info.v4l_1, elements);
  };
}
function KSerialiserJson$toJson$lambda_6($currentObjStack) {
  return function (path, info, type, coll) {
    var tmp;
    if (type.isArray) {
      tmp = ComplexObjectKind_ARRAY_getInstance().b4g();
    } else if (type.isList) {
      tmp = ComplexObjectKind_LIST_getInstance().b4g();
    } else if (type.isSet) {
      tmp = ComplexObjectKind_SET_getInstance().b4g();
    } else {
      throw KSerialiserJsonException.new_net_akehurst_kotlin_kserialisation_json_KSerialiserJsonException('Unknown type ' + type);
    }
    var jsonTypeName = tmp;
    var elements = $currentObjStack._v.pop();
    var setObj = new JsonUnreferencableObject();
    setObj.r4f(Companion_getInstance().c4g_1, jsonTypeName);
    setObj.r4f(Companion_getInstance().g4g_1, elements);
    return new WalkInfo(info.v4l_1, setObj);
  };
}
function KSerialiserJson$toJson$lambda_7($currentObjStack) {
  return function (path, info, map) {
    var obj = new JsonUnreferencableObject();
    obj.r4f(Companion_getInstance().c4g_1, ComplexObjectKind_MAP_getInstance().b4g());
    obj.r4f(Companion_getInstance().h4g_1, new JsonArray());
    $currentObjStack._v.push(obj);
    return new WalkInfo(info.v4l_1, obj);
  };
}
function KSerialiserJson$toJson$lambda_8($currentObjStack) {
  return function (path, info, entry) {
    $currentObjStack._v.push(info.w4l_1);
    return info;
  };
}
function KSerialiserJson$toJson$lambda_9($currentObjStack) {
  return function (path, info, entry) {
    var meKey = $currentObjStack._v.pop();
    var meValue = info.w4l_1;
    var tmp = $currentObjStack._v.peek();
    var mapObj = tmp instanceof JsonObject ? tmp : THROW_CCE();
    var tmp0_elvis_lhs = mapObj.q4f_1.u3(Companion_getInstance().h4g_1);
    var tmp_0 = tmp0_elvis_lhs == null ? new JsonArray() : tmp0_elvis_lhs;
    var mapElements = tmp_0 instanceof JsonArray ? tmp_0 : THROW_CCE();
    var neEl = new JsonUnreferencableObject();
    neEl.r4f(Companion_getInstance().e4g_1, meKey);
    neEl.r4f(Companion_getInstance().f4g_1, meValue);
    mapElements.p4f(neEl);
    return new WalkInfo(info.v4l_1, mapObj);
  };
}
function KSerialiserJson$toJson$lambda_10($currentObjStack) {
  return function (path, info, map) {
    var obj = $currentObjStack._v.pop();
    return new WalkInfo(info.v4l_1, obj);
  };
}
function KSerialiserJson$toJson$lambda_11($doc, this$0, $currentObjStack) {
  return function (path, info, obj, datatype) {
    var json = new JsonReferencableObject($doc, path);
    var tmp0_set = this$0.l4m_1;
    var tmp1_set = json.l4g_1;
    tmp0_set.m3(obj, tmp1_set);
    json.r4f(Companion_getInstance().c4g_1, ComplexObjectKind_OBJECT_getInstance().b4g());
    json.r4f(Companion_getInstance().d4g_1, new JsonString(datatype.qualifiedName));
    $currentObjStack._v.push(json);
    return new WalkInfo(path, json);
  };
}
function KSerialiserJson$toJson$lambda_12($currentObjStack) {
  return function (path, info, obj, datatype) {
    var obj_0 = $currentObjStack._v.pop();
    return new WalkInfo(info.v4l_1, obj_0);
  };
}
function KSerialiserJson$toJson$lambda_13(path, info, property) {
  return info;
}
function KSerialiserJson$toJson$lambda_14($currentObjStack) {
  return function (path, info, property) {
    var key = last(path);
    var tmp = $currentObjStack._v.peek();
    var cuObj = tmp instanceof JsonObject ? tmp : THROW_CCE();
    cuObj.r4f(typeof key === 'string' ? key : THROW_CCE(), info.w4l_1);
    return new WalkInfo(info.v4l_1, cuObj);
  };
}
var TestEnumEEE_RED_instance;
var TestEnumEEE_GREEN_instance;
var TestEnumEEE_BLUE_instance;
function values() {
  return [TestEnumEEE_RED_getInstance(), TestEnumEEE_GREEN_getInstance(), TestEnumEEE_BLUE_getInstance()];
}
function valueOf_1(value) {
  switch (value) {
    case 'RED':
      return TestEnumEEE_RED_getInstance();
    case 'GREEN':
      return TestEnumEEE_GREEN_getInstance();
    case 'BLUE':
      return TestEnumEEE_BLUE_getInstance();
    default:
      TestEnumEEE_initEntries();
      THROW_ISE();
      break;
  }
}
var TestEnumEEE_entriesInitialized;
function TestEnumEEE_initEntries() {
  if (TestEnumEEE_entriesInitialized)
    return Unit_getInstance();
  TestEnumEEE_entriesInitialized = true;
  TestEnumEEE_RED_instance = new TestEnumEEE('RED', 0);
  TestEnumEEE_GREEN_instance = new TestEnumEEE('GREEN', 1);
  TestEnumEEE_BLUE_instance = new TestEnumEEE('BLUE', 2);
}
function TestEnumEEE_RED_getInstance() {
  TestEnumEEE_initEntries();
  return TestEnumEEE_RED_instance;
}
function TestEnumEEE_GREEN_getInstance() {
  TestEnumEEE_initEntries();
  return TestEnumEEE_GREEN_instance;
}
function TestEnumEEE_BLUE_getInstance() {
  TestEnumEEE_initEntries();
  return TestEnumEEE_BLUE_instance;
}
//region block: post-declaration
setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(FromJsonConverter, 'FromJsonConverter', classMeta);
setMetadataFor(KSerialiserJsonException, 'KSerialiserJsonException', classMeta);
setMetadataFor(FoundReferenceException, 'FoundReferenceException', classMeta);
setMetadataFor(KSerialiserJson, 'KSerialiserJson', classMeta);
setMetadataFor(TestEnumEEE, 'TestEnumEEE', classMeta);
setMetadataFor(TestClassAAA, 'TestClassAAA', classMeta);
//endregion
//region block: exports
KSerialiserJson.FoundReferenceException = FoundReferenceException;
TestEnumEEE.values = values;
TestEnumEEE.valueOf = valueOf_1;
export {
  FromJsonConverter,
  KSerialiserJsonException,
  KSerialiserJson,
  TestEnumEEE,
  TestClassAAA,
};
export {
  KSerialiserJson as a,
};
//endregion

//# sourceMappingURL=net.akehurst.kotlin.kserialisation-kserialisation-json.mjs.map
